var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5C4.5 5.96957 4.71071 5.46086 5.08579 5.08579C5.46086 4.71071 5.96957 4.5 6.5 4.5L7.5 6.5L6.73 7.65438C7.03544 8.38421 7.61579 8.96456 8.34562 9.27L9.5 8.5L11.5 9.5C11.5 10.0304 11.2893 10.5391 10.9142 10.9142C10.5391 11.2893 10.0304 11.5 9.5 11.5C8.17392 11.5 6.90215 10.9732 5.96447 10.0355C5.02678 9.09785 4.5 7.82608 4.5 6.5Z",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99554 13.1944C6.25588 13.9238 7.73847 14.17 9.16691 13.887C10.5953 13.6041 11.8721 12.8113 12.7592 11.6565C13.6463 10.5017 14.0831 9.06364 13.9883 7.61054C13.8934 6.15744 13.2734 4.78843 12.2437 3.75874C11.214 2.72905 9.84497 2.10898 8.39187 2.01412C6.93876 1.91927 5.50076 2.3561 4.34595 3.24319C3.19114 4.13027 2.39835 5.40706 2.11539 6.8355C1.83243 8.26394 2.07862 9.74653 2.80804 11.0069L2.02617 13.3412C1.99679 13.4293 1.99253 13.5239 2.01386 13.6143C2.03519 13.7046 2.08127 13.7873 2.14694 13.853C2.2126 13.9186 2.29526 13.9647 2.38565 13.9861C2.47603 14.0074 2.57057 14.0031 2.65867 13.9737L4.99554 13.1944Z",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappReferral);
export default __webpack_public_path__ + "static/media/WhatsappReferral.210e186f6fc17966eab7210415dd1638.svg";
export { ForwardRef as ReactComponent };